// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-search
 * @tagname hzn-icon-search
 * @summary An individual icon for Horizon
 */
export class HznIconSearch extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 8.97764C5 6.25996 7.28805 4 10.1818 4C13.0756 4 15.3636 6.25996 15.3636 8.97764C15.3636 11.6953 13.0756 13.9553 10.1818 13.9553C7.28805 13.9553 5 11.6953 5 8.97764ZM10.1818 2C6.24733 2 3 5.0926 3 8.97764C3 12.8627 6.24733 15.9553 10.1818 15.9553C11.6394 15.9553 13.0026 15.5309 14.1414 14.799L20.5581 21.0037L21.9958 19.6134L15.6619 13.4887C16.7213 12.2766 17.3636 10.7055 17.3636 8.97764C17.3636 5.0926 14.1163 2 10.1818 2Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=search.js.map